<div class="wrap">
  <mat-dialog-content>
    <h2>Update {{ data.license.client.name }} license</h2>
    <form
      [formGroup]="UpdateLicenseForm"
      (ngSubmit)="onSubmit()"
      *ngIf="!isLoading"
    >
      <div class="add_uses_title" *ngIf="data.license.usesRemaining != null">
        <h4>Uses remaining</h4>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>Type</mat-label>
        <mat-select appearance="outline" formControlName="type">
          <mat-option *ngFor="let t of types" [value]="t">{{
            t.name
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="uses_line" *ngIf="UpdateLicenseForm.value.type.id != 2">
        <mat-form-field appearance="outline">
          <mat-label>Number of uses to add</mat-label>
          <input matInput formControlName="addedUses" type="number" />
          <mat-error> Must be a positive number </mat-error>
          <!-- Mettre une maat icon juste ici au lieu du badge -->
        </mat-form-field>
        <div class="uses">
          <span class="final">{{
            data.license.type.name != "Unlimited"
              ? data.license.usesRemaining
              : 0
          }}</span>
          <fa-icon [icon]="faArrow" />
          <div *ngIf="UpdateLicenseForm.controls.addedUses.invalid; else valid">
            <!-- matBadge="!"
            matBadgeColor="warn"
            matBadgeOverlap="false" -->
            <span class="final">{{
              data.license.type.name != "Unlimited"
                ? data.license.usesRemaining
                : 0
            }}</span>
          </div>
          <ng-template #valid
            ><span class="final">{{
              (data.license.usesRemaining != null
                ? data.license.usesRemaining
                : 0) + UpdateLicenseForm.value.addedUses
            }}</span></ng-template
          >
        </div>
      </div>

      <mat-slide-toggle
        [checked]="true"
        class="checkbox"
        [color]="color"
        formControlName="hasExpiryDate"
        >Has expiry date</mat-slide-toggle
      >
      <!-- Slide toggle -->

      <mat-form-field
        appearance="outline"
        *ngIf="UpdateLicenseForm.value.hasExpiryDate"
      >
        <mat-label>Expiry date</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          [placeholder]="data.license.expiryDate | date : 'shortDate'"
          [disabled]="!UpdateLicenseForm.value.hasExpiryDate"
          formControlName="expiryDate"
        />
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error>Please enter a date like DD/MM/YYYY</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Comment</mat-label>
        <!-- // rassembler colonne action -->
        <textarea
          matInput
          placeholder="Leave a comment about this license..."
          formControlName="comment"
          maxlength="200"
        ></textarea>
      </mat-form-field>

      <div class="btn_action">
        <button class="canceled" type="button" (click)="dialog.closeAll()">
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="UpdateLicenseForm.invalid"
          [ngClass]="{
            isInactive: UpdateLicenseForm.invalid,
            isActive: UpdateLicenseForm.valid
          }"
        >
          Update
        </button>
      </div>
    </form>
    <mat-spinner *ngIf="isLoading" color="primary" diameter="50"></mat-spinner>
  </mat-dialog-content>
</div>
